import { render, staticRenderFns } from "./FooterSubFooter.vue?vue&type=template&id=36911556&lang=pug&"
import script from "./FooterSubFooter.vue?vue&type=script&lang=js&"
export * from "./FooterSubFooter.vue?vue&type=script&lang=js&"
import style0 from "./FooterSubFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36911556')) {
      api.createRecord('36911556', component.options)
    } else {
      api.reload('36911556', component.options)
    }
    module.hot.accept("./FooterSubFooter.vue?vue&type=template&id=36911556&lang=pug&", function () {
      api.rerender('36911556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/footer/FooterSubFooter.vue"
export default component.exports